import { create } from 'zustand';
import i18n from 'i18n';
import { AccountsApi, ApiUtils, type GetCardExpirationsResponse, type GetCardLimitsResponse } from '@shared/api';
import type { BaseReturn } from '@shared/types';

interface GetCardDetailsReturn {
  cardId: number;
  expiryDate: GetCardExpirationsResponse['expiryDate'];
  limits: GetCardLimitsResponse;
}

interface UseCardDetailsStore {
  loading: boolean;
  data: GetCardDetailsReturn | null;
  error?: string | null;
  getCardDetails: (cardId: number) => Promise<BaseReturn<GetCardDetailsReturn | null>>;
  clear: () => void;
}

export const useCardDetailsStore = create<UseCardDetailsStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  getCardDetails: async (cardId) => {
    try {
      set({ loading: true, data: null, error: null });
      const [expirationsResult, limitsResult] = await Promise.all([AccountsApi.getCardExpirations(cardId), AccountsApi.getCardLimits(cardId)]);
      const result: GetCardDetailsReturn = { cardId, expiryDate: expirationsResult.expiryDate, limits: limitsResult };
      set({ loading: false, data: result || null });
      return { loading: false, data: result || null };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
